// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1lvmZ","loaderOuter":"PageOverlayLoader_loaderOuter__DYNLm"};